import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const cookieStatus = localStorage.getItem("cookieConsent");
    if (!cookieStatus) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-container">
        <div className="cookie-content">
          <h3>🍪 Cookies Notice</h3>
          <p>
            We use cookies and similar technologies to enhance platform security, enable secure account authentication, 
            improve platform performance, and analyze user activity.
            <br /><br />
            Cookies may be used for session management, fraud prevention, analytics, 
            and storing user preferences to provide a better user experience on the platform.
            <br /><br />
            Investments may involve financial risk. By continuing to use this platform, 
            you acknowledge and accept our use of cookies in accordance with our Cookies Policy.
          </p>
        </div>

        <div className="cookie-buttons">
          <button className="reject-btn" onClick={handleReject}>
            Reject
          </button>
          <button className="accept-btn" onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>

      <style>{`
        .cookie-overlay {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          padding: 20px;
          z-index: 9999;
        }
      button{
          overflow: hidden;
      }
        .cookie-container {
          background: #0f172a;
          color: #fff;
          max-width: 1200px;
          width: 100%;
          border-radius: 12px;
          padding: 24px;
          // display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 30px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.5);
        }

        .cookie-content {
          flex: 2;
          max-height: 200px;
          overflow-y: auto;
        }

        .cookie-content h3 {
          margin-bottom: 12px;
        }

        .cookie-content p {
          font-size: 14px;
          line-height: 1.6;
          margin: 0;
        }

        .cookie-buttons {
          flex: 1;
          display: flex;
          gap: 15px;
          justify-content: flex-end;
             margin-top:40px;
        }

        .reject-btn {
             background: transparent;
    border: 1px solid #fff;
    color: #fff;
    padding: 10px 18px;
    border-radius: 6px;
    cursor: pointer;
    line-height: unset;
    font-size: 15px;
    height: auto;
        }
     .reject-btn:hover { 
    border: 1px solid #fff;
    color: #fff; 
        }

        .accept-btn {
          background: #00d1b2;
          border: none;
          color: #000;
          padding: 10px 18px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
           line-height: unset;
    font-size: 15px;
    height: auto;
        }
     .accept-btn:hover {
          background: #00d1b2; 
        }
 
        /* Tablet */
        @media (max-width: 992px) {
          .cookie-container {
            flex-direction: column;
            align-items: flex-start;
          }

          .cookie-buttons {
            width: 100%;
        
            justify-content: flex-start;
          }
        }

        /* Mobile */
        @media (max-width: 600px) {
          .cookie-container {
            padding: 18px;
          }

          .cookie-content {
            max-height: 250px;
          }

          .cookie-buttons {
            flex-direction: column;
            width: 100%;
          }

          .reject-btn,
          .accept-btn {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;